const sampleProducts = [
  {
    id: 1,
    name: "iPhone 17",
    category: "phones",
    price: 999.99,
    image: "/images/iphone-17.jpg",
    description:
      "The latest iPhone with A19 Pro chip, stunning camera, and dynamic display.",
  },
  {
    id: 2,
    name: "Samsung Galaxy S25",
    category: "phones",
    price: 899.99,
    image: "/images/galaxy-S25.jpg",
    description:
      "Experience cutting-edge performance and AI-powered photography.",
  },
  {
    id: 3,
    name: "Google Pixel 10",
    category: "phones",
    price: 749.99,
    image: "/images/pixel-10.jpg",
    description:
      "Google's clean Android experience with a brilliant Tensor G5 chip.",
  },
  {
    id: 4,
    name: "MacBook Pro M4",
    category: "laptops",
    price: 1799.99,
    image: "/images/macbook.jpg",
    description:
      "Apple’s powerhouse laptop — faster, cooler, and perfect for creators.",
  },
  {
    id: 5,
    name: "Dell Inspiron",
    category: "laptops",
    price: 699.99,
    image: "/images/dell-inspiron.jpg",
    description:
      "Ultra-thin design, vivid display, and powerful Intel performance.",
  },
  {
    id: 6,
    name: "HP OmniBook Ultra",
    category: "laptops",
    price: 1199.99,
    image: "/images/hp-omnibook.jpg",
    description: "HP Ultra laptop with sleek design and long battery life.",
  },
];

export default sampleProducts;
